import {Injectable} from '@angular/core';
import {SocketMessagesService} from '../core/socket/socket.service';
import {Observable, of, Subject} from 'rxjs';
import {IAudioInput} from '../types';
import {distinctUntilChanged, filter, map, pluck, shareReplay, switchMap, tap} from 'rxjs/operators';
import {AuthService} from '../core/auth.service';
import { uniqBy } from 'lodash';
/**
 * @deprecated
 */
interface IExternalAudioInput extends IAudioInput {
    organisations: number[];
}

@Injectable({
    providedIn: 'root'
})
export class AudioSourcesService {
    private audio$$: Subject<IAudioInput[]> = new Subject<IAudioInput[]>();
    public reloadAudio$$: Subject<void> = new Subject<void>();
    public audio$: Observable<IAudioInput[]> = this.audio$$.asObservable().pipe(
        shareReplay(1)
    );
    private audioOrgCache: Map<number, IAudioInput[]> = new Map<number, IAudioInput[]>();


    constructor(
        private messages: SocketMessagesService,
        private auth: AuthService,
    ) {
        this.reloadAudio$$.asObservable().pipe(
            tap(() => this.audioOrgCache.clear()),
            switchMap(() => this.getAudioInputs$()),
            tap(this.audio$$.next.bind(this.audio$$))
        ).subscribe();

        // Defer until session is established after refresh (avoids racing reLogin → spurious "App token not valid").
        this.auth.isLoggedIn$.pipe(
            distinctUntilChanged(),
            filter((loggedIn) => loggedIn === true),
            tap(() => this.reloadAudio$$.next())
        ).subscribe();
    }

    public getAudioMap$(): Observable<Map<number, IAudioInput>> {
        return this.audio$.pipe(
            map(audios => {
                return new Map(audios.map(audio => {
                    return [audio.audio_input_id as number, audio];
                }));
            })
        );
    }

    public getAudioByOrg$(orgId: number, showOnly?: string): Observable<IAudioInput[]> {
        let audio_sources = uniqBy(
            (this.audioOrgCache.has(orgId)) ? this.audioOrgCache.get(orgId) as IAudioInput[] : [],
            'audio_input_id'
        )

        if (showOnly) {
            audio_sources = audio_sources?.filter((a: IAudioInput) => a?.audio_name === showOnly)
        }

        return of(audio_sources);
    }

    public setAudioInputs() {
        return this.getAudioInputs$();
    }

    private getAudioInputs$(): Observable<IAudioInput[]> {

        // @ts-ignore
        return this.messages.request$<{ audio_inputs: IExternalAudioInput[] }>('getAudioInputs').pipe(
            pluck('audio_inputs'),
            tap((audios: any) => {
                audios.forEach((audio: any) => {
                    audio.organisations.forEach((org_id: any) => {
                        if (this.audioOrgCache.has(org_id)) {
                            const organizationAudios = this.audioOrgCache.get(org_id) as IAudioInput[];
                            organizationAudios.push(audio);
                            this.audioOrgCache.set(org_id, organizationAudios);
                        } else {
                            this.audioOrgCache.set(org_id, [audio]);
                        }
                    });
                });
            })
        );
    }

    public reloadAudio() {
        this.reloadAudio$$.next();
    }
}
